import { DefaultUrlSerializer } from '@angular/router';

import { MenuItemAdvania } from '../menu/menu-utils';

const breadcrumbWordLabels: Record<string, string> = {
    it: 'IT',
    lan: 'LAN',
    pc: 'PC',
    wan: 'WAN',
    wifi: 'WiFi',
    wlan: 'WLAN',
    ai: 'AI',
};

const minorBreadcrumbWords = new Set(['a', 'an', 'and', 'at', 'by', 'for', 'in', 'of', 'on', 'the', 'to']);
const urlSerializer = new DefaultUrlSerializer();

function shouldPreserveBreadcrumbSegment(segment: string): boolean {
    return /\d/.test(segment) || /[A-Z]/.test(segment);
}

function toTitleCase(value: string): string {
    return value.charAt(0).toUpperCase() + value.slice(1);
}

export function formatBreadcrumbSegment(segment: string): string {
    const normalizedSegment = segment.trim();

    if (!normalizedSegment) {
        return segment;
    }

    if (shouldPreserveBreadcrumbSegment(normalizedSegment)) {
        return normalizedSegment;
    }

    const words = normalizedSegment.toLowerCase().split(/[-_]+/).filter(Boolean);

    return words
        .map((word, index) => {
            const label = breadcrumbWordLabels[word];

            if (label) {
                return label;
            }

            const isMinorWord = index > 0 && index < words.length - 1 && minorBreadcrumbWords.has(word);

            if (isMinorWord) {
                return word;
            }

            return toTitleCase(word);
        })
        .join(' ');
}

export function toBreadcrumbSegments(currentUrl: string): MenuItemAdvania[] {
    const urlTree = urlSerializer.parse(currentUrl);
    const urlSegments = urlTree.root.children['primary']?.segments.map((segment) => segment.path) ?? [];
    const featureSegments = urlSegments.slice(1);

    if (featureSegments.length === 0) {
        return [];
    }

    if (featureSegments.length === 1 && featureSegments[0].toLowerCase() === 'home') {
        return [];
    }

    return featureSegments.map((segment, index) => {
        const fullPath = ['/', ...urlSegments.slice(0, index + 2)];

        return {
            label: formatBreadcrumbSegment(segment),
            routerLink: fullPath,
            url: '/' + urlSegments.slice(0, index + 2).join('/'),
        };
    });
}
